import api from "../api";

export default function getFeedSourceContent(feedSourceId) {
  return api.get(`/admin/content/feedSources/${feedSourceId}`);
}
